<template>
  <v-card elevation="1">
    <div class="flex w-full rounded-tl-sm rounded-tr-sm">
      <v-card-title style="color: var(--darkBlue)">
        <v-row>
          <v-col class="text-lg-left text-center" lg="5" cols="12">
            <h3>{{ $t('navigationDrawerMenu.customizationManagement') }}</h3>
          </v-col>
        </v-row>
      </v-card-title>
    </div>
    <v-row>
      <FormElement
        v-model="companyLogo"
        :validationLabel="$t('labels.companyLogo')"
        :formLabel="$t('labels.companyLogo')"
        :onChange="handleLogoUpload"
        :formType="{
          name: 'file',
          type: 'image',
          dense: true,
          data: {
            lazy: companyInfo?.PhotoUrl,
            source: companyInfo?.PhotoUrl,
            accept: 'image/png, image/jpeg, image/bmp',
          },
        }"
        :labelShown="false"
        :cols="6"
        :sm="6"
        :md="6"
        :lg="6"
        :xl="6"
        :topLabel="true"
        :hideDetails="true"
        :placeholder="$t('labels.companyLogo')"
      />
      <v-col cols="6" class="d-flex justify-center items-center">
        <v-color-picker v-model="companyColor" hide-inputs></v-color-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn
          style="
            color: #fff;
            text-transform: unset !important;
            background-color: #0077d5;
            padding: 2vh 4vh;
            border-radius: 30px !important;
            font-weight: bolder;
          "
          elevation="0"
          class="darken-1 mt-4 mx-auto"
          type="submit"
          @click="updateCompanyInfo"
        >
          {{ $t('buttons.save') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import FormElement from '../components/FormElement.vue';
import PortalCustomization from '../services/PortalCustomization';
import FileService from '../services/FileService';

export default {
  data() {
    return {
      companyInfo: {
        Id: null,
        PhotoUrl: null,
        Color: null,
      },
      companyLogo: null,
      companyColor: null,
      isLogoChanged: false,
    };
  },
  components: {
    FormElement,
  },
  mounted() {
    this.getCompanyInfo();
  },
  methods: {
    async getCompanyInfo() {
      this.$store.state.loadingStatus = true;
      try {
        const response = await PortalCustomization.get();

        this.companyInfo = {
          Id: response.data.Result?.Id,
          PhotoUrl: response.data.Result
            ? response.data.Result.LogoUrl
            : 'https://algonder.s3.amazonaws.com//1738758922389645340logo.png?AWSAccessKeyId=AKIA5TWV25RSSAFBF64U&Expires=2054291722&Signature=FqO2uCQKrFaxsg3iplgdOU74y7k%3D',
          Color: response.data.Result ? response.data.Result.Color : '#1a305c',
        };
        this.companyColor = this.companyInfo.Color;
      } catch (error) {
        console.error('Error fetching company info:', error);
      } finally {
        this.$store.state.loadingStatus = false;
      }
    },
    async handleLogoUpload(event) {
      this.isLogoChanged = true;
    },

    async uploadMethod() {
      const formData = new FormData();
      formData.append('Files', this.companyLogo);
      formData.append('Type', 'media');
      const response = await FileService.uploadFile(formData);
      return response.data.Result[0].Url;
    },
    async updateCompanyInfo() {
      this.$store.state.loadingStatus = true;
      let url = this.companyInfo.PhotoUrl;

      if (this.isLogoChanged) {
        url = await this.uploadMethod();
      }

      try {
        if (this.companyInfo.Id) {
          const payload = {
            Id: this.companyInfo.Id,
            LogoUrl: url,
            Color: this.companyColor,
          };

          await PortalCustomization.update(payload);
        } else {
          const payload = {
            LogoUrl: url,
            Color: this.companyColor,
          };

          console.log(payload);

          await PortalCustomization.add(payload);
        }
      } catch (error) {
        console.error('Error updating company info:', error);
      } finally {
        this.isLogoChanged = false;
        this.$store.state.loadingStatus = false;
        this.getCompanyInfo();
      }
    },
  },
};
</script>
